<template>
  <div class="flex w-full loginWrapper">
    <CustomToast />
    <div class="w-[50%] py-9 bg-[#FCF9F4] min-h-screen">
      <section class="w-10/12 mx-auto">
        <img
          src="@/assets/svg/navlogo.svg"
          alt=""
          class="w-[2.8125rem] h-[4.0569rem]"
        />
        <div class="illustration mt-[60px]">
          <img src="@/assets/svg/Gas_station_shop.svg" alt="" class="w-11/12" />
        </div>
        <div class="text mt-[60px]">
          <p class="mb-4 text-3xl font-semibold font-sfPro">
            {{ $t("login.leftHeader") }}
          </p>
          <p class="font-normal text-gray-700 font-sfPro">
            {{ $t("login.leftText") }}
          </p>
        </div>
      </section>
    </div>
    <div class="right">
      <form @submit="login" class="login-main pt-24 pl-32 pr-[292px]">
        <div class="text mb-14">
          <p class="text-5xl font-millik">{{ $t("login.rightHeader") }}</p>
          <p class="mt-2 text-gray-700 font-sfPro">
            {{ $t("login.rightSubText") }}
          </p>
        </div>
        <div class="inputs w-[486px]">
          <EpumpInputVue
            :required="true"
            class="mb-5"
            :label="'Email address'"
            :passwordRevealToggle="false"
            :clearSearch="false"
            :placeholder="'email@example.com'"
            :status="'active'"
            :type="'email'"
            :forgotPassword="false"
            :validation="false"
            @input="setUsername($event)"
            ><img src="@/assets/svg/sms.svg"
          /></EpumpInputVue>
          <EpumpInputVue
            class="mb-8"
            :required="true"
            :label="'Password'"
            :passwordRevealToggle="true"
            :clearSearch="false"
            :placeholder="'password'"
            :hintMessage="errors.message"
            :status="'active'"
            :type="'password'"
            :forgotPassword="true"
            :validation="false"
            @input="setPassword($event)"
            ><img src="@/assets/svg/lock.svg"
          /></EpumpInputVue>
          <Button
            class="bg-[#000]"
            :theme="'blackSolid'"
            :size="'large'"
            :disabled="loading"
            :radius="'large'"
            @click="login"
          >
            <p
              v-if="!loading"
              class="text-estationsGreen-400 font-medium text-[16px]"
            >
              {{ $t("login.signIn") }}
            </p>
            <ClipLoaderVue v-else color="estationsGreen-400" :size="20" />
          </Button>
          <div class="mt-5 text-sm text-center contatct font-sfPro">
            <span class="font-medium text-[#98A2B3]">{{
              $t("login.contactGrey")
            }}</span>
            <router-link to="/contact">
              <span class="font-bold text-estationsGreen-500">{{
                $t("login.contactGreen")
              }}</span>
            </router-link>
          </div>
        </div>
      </form>

      <!-- <div class="flex justify-end px-24 py-5 faq">
        <img src="@/assets/svg/faq.svg" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
import EpumpInputVue from "@/components/UI/Inputs/EpumpInput.vue";
import Button from "@/components/UI/Buttons/Button.vue";
import { useAuthStore } from "@/store/Auth";
import ClipLoaderVue from "@/components/UI/Loader/ClipLoaderVue.vue";
import { errorToast, successToast } from "@/core/helpers/utility";
import { ALLOWED_ROLES, ROLE_REDIRECTS } from "@/core/helpers/roles";
import { useEntityStore } from "@/store/Entity";
import { mapActions, mapState } from "pinia";
const authStore = useAuthStore();
export default {
  components: {
    ClipLoaderVue,
    EpumpInputVue,
    Button,
  },
  computed: {
    isErrorEmpty() {
      return Object.keys(this.errors).length === 0;
    },
  },
  data() {
    return {
      loginValues: {
        username: "",
        password: "",
      },
      errors: {},
      loading: false,
    };
  },
  computed: {
    ...mapState(useEntityStore, ["entityDetails"]),
  },
  mounted() {
    // this.resetStore();
    // localStorage.clear();
  },
  methods: {
    ...mapActions(useEntityStore, ["resetStore", "getEntity"]),

    setUsername(e) {
      const value = e.target?.value;
      if (value) {
        this.loginValues.username = e.target.value;
      }
    },
    setPassword(e) {
      const value = e.target?.value;
      if (value) {
        this.loginValues.password = e.target.value;
      }
    },
    login() {
      this.loading = true;
      authStore.errors = {};
      authStore
        .login(this.loginValues)
        .then((response) => {
          // successToast(this.$t("common.loginSuccess"));
          this.roleRedirection(response);
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.message ??
            error?.data?.message ??
            "An error occurred";

          if (errorMessage?.includes("ForcePasswordChange")) {
            this.$router.push({ name: "forgot-password" });
          }
        })
        .finally(() => (this.loading = false));
    },
    roleRedirection(response) {
      // Validate at least one valid role exists
      const hasValidRole = ALLOWED_ROLES.some((role) =>
        response.role.includes(role)
      );

      if (!hasValidRole) {
        localStorage.clear();
        errorToast(this.$t("login.noAccess"));
        return;
      }

      // ⌛ Handle authenticated redirection(might need later)
      // if (authStore.isAuthenticated) {
      //   const userRoles = response.role;

      //   const matchedRole = Object.keys(ROLE_REDIRECTS).find(role =>
      //     userRoles.includes(role)
      //   );

      //   this.$router.push({
      //     name: matchedRole ? ROLE_REDIRECTS[matchedRole] : ROLE_REDIRECTS.default
      //   });
      // } else {
      //   this.errors = authStore.errors;
      // }

      if (authStore.isAuthenticated && response.role.includes("SupportAdmin")) {
        this.$router.push({ name: "company-list" });
      } else if (
        authStore.isAuthenticated &&
        response.role.includes("Company")
      ) {
        this.$router.push({ name: "dashboard" });
      } else if (authStore.isAuthenticated) {
        this.$router.push({ name: "dashboard" });
      } else {
        this.errors = authStore.errors;
      }
    },
  },
};
</script>
